// src/components/icons/OdooIcon.jsx
import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as OdooSvg } from './odoo.svg';

const OdooIcon = React.forwardRef(function OdooIcon(props, ref) {
  // inheritViewBox permette di utilizzare il viewBox del file SVG
  return <SvgIcon component={OdooSvg} inheritViewBox ref={ref} {...props} />;
});

export default OdooIcon;
